// import {handleFileSend, handleSend} from '../handleSend'

import {handleFileSend, handleSend} from '../handleSend'

export const ProgramApi = {
  // 新增/修改屏位接口（47,2001
  handleScreen (data, type = 0) {
    return handleSend(data, '47', '2001', String(type))
  },
  // 查询屏位资料接口（47,2002
  queryScreenList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '47', '2002', '0', 'message')
  },
  // 删除屏位接口（47,2003
  deleteScreen (data) {
    return handleSend(data, '47', '2003')
  },
  // 新增/修改特色菜接口（47,5001
  handleDish (data, type = 0) {
    return handleSend(data, '47', '5001', String(type))
  },
  // 查询特色菜接口（47,5002
  queryDishList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '47', '5002', '0', 'message')
  },
  // 删除特色菜接口（47,5003
  deleteDish (data) {
    return handleSend(data, '47', '5003')
  },
  // 新增/修改节目表接口（47,3001
  handleProgram (data, type = 0) {
    return handleSend(data, '47', '3001', String(type))
  },
  // 视频文件上传接口（47,3002
  uploadProgramVideo (data, content = '', fileType = '0') {
    let fd = new FormData() // FormData 对象
    fd.append('file', data) // 文件对象
    fd.append('fileType', fileType)
    fd.append('content', content)
    fd.append('AppCode', '47')
    fd.append('BizCode', '3002')
    return handleFileSend('/uploadFiles', '47', '3002', fd, 'message')
  },
  // 查询节目单接口（47,3003
  queryProgramList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '47', '3003', '0', 'message')
  },
  // 删除节目单接口（47,3004
  deleteProgram (data) {
    return handleSend(data, '47', '3004')
  },
  // 创建/修改播放计划接口（47,4001
  handleBroadcastPlan (data, type = 0) {
    return handleSend(data, '47', '4001', String(type))
  },
  // 查询播放计划接口（47,4002
  queryBroadcastPlanList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '47', '4002', '0', 'message')
  },
  // 删除播放计划接口（47,4003
  deleteBroadcastPlan (data) {
    return handleSend(data, '47', '4003')
  },
  // 播放/停播接口（47,4004
  playAndPause (data, type) {
    return handleSend(data, '47', '4004', String(type))
  }
}



// WEBPACK FOOTER //
// ./src/request/Program/program_api.js